module.exports = __webpack_public_path__ + "static/media/wedding.3188b928.jpeg";